export default __webpack_public_path__ + "static/media/Group9196.c355a43c.svg";